import {
  motion,
  useMotionValue,
  useTransform,
  useSpring,
  useVelocity,
} from "framer-motion";
import { useEffect } from "react";
import ChipContent from "./ChipContent";

function ChipDragOverlay({ skill, skillType, transform }) {
  const motionX = useMotionValue(transform?.x ?? 0);
  const velocityX = useVelocity(motionX);

  const rotate = useTransform(velocityX, [-200, 200], [-20, 20]);
  const springRotate = useSpring(rotate, { damping: 20, stiffness: 150 });

  useEffect(() => {
    if (transform) {
      motionX.set(transform.x);
    }
  }, [transform, motionX]);

  if (!skill) return null;

  const isAiGeneratedForSkillType =
    skill.ai.isGenerated && skill.ai.skillType === skillType;

  return (
    <motion.div
      style={{
        rotate: springRotate,
      }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 25,
      }}
      layoutId={`chip-${skill.name}`}
      layout
      id={`overlay-chip-${skill.name}`}
    >
      <ChipContent
        skill={skill}
        active={skill.active}
        isAiGenerated={isAiGeneratedForSkillType}
        ref={undefined}
        isOverlay
      />
    </motion.div>
  );
}

export default ChipDragOverlay;
